import React from "react";
import { sortBy } from "lodash";
import { db } from "../services/firebase";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderField, renderSelect } from "./_fieldRenderer";

import "./forms.css";

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Obrigatório";
  }
  if (!values.email) {
    errors.email = "Obrigatório";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Email inválido";
  }
  if (!values.password) {
    errors.password = "Obrigatório";
  } else if (values.password.length < 6) {
    errors.password = "Min. 6 caracteres";
  }
  if (!values.role) {
    errors.role = "Obrigatório";
  }
  if (!values.company) {
    errors.company = "Obrigatório";
  }
  return errors;
};

class UserForm extends React.Component {
  state = {
    roles: [],
    companies: [],
    shifts: [],
    fetchingRoles: false,
    fetchingCompanies: false,
    fetchingShifts: false,
  };

  componentDidMount() {
    const { initialValues } = this.props;
    const roles = [];
    const companies = [];
    const shifts = [];

    this.setState({ fetchingCompanies: true, fetchingRoles: true });

    db.collection("roles")
      .get()
      .then((roleSnapshot) => {
        roleSnapshot.forEach((role) =>
          roles.push({
            value: role.id,
            label: role.data().name,
          })
        );
        this.setState({ roles, fetchingRoles: false });
      })
      .catch((e) => console.log(e));

    db.collection("companies")
      .where("active", "==", true)
      .get()
      .then((companySnapshot) => {
        companySnapshot.forEach((company) =>
          companies.push({
            value: company.id,
            label: `${company.data().name} (${company.data().city}, ${
              company.data().state
            })`,
          })
        );
        this.setState({ companies, fetchingCompanies: false });
      })
      .catch((e) => console.log(e));

    if (initialValues) {
      this.setState({ shifts, fetchingShifts: true });
      db.collection("companies")
        .doc(initialValues.company)
        .collection("shifts")
        .get()
        .then((shiftSnapshot) => {
          shiftSnapshot.forEach((shift) =>
            shifts.push({
              value: shift.id,
              label: `${shift.data().name}`,
            })
          );
          this.setState({ shifts, fetchingShifts: false });
        })
        .catch((e) => console.log(e));
    }
  }

  render() {
    const { handleSubmit, submitting, initialValues, change } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="company"
                component={renderSelect}
                label="Empresa"
                disabled={!this.state.companies.length}
                placeholder={this._handlePlaceholder(this.state.companies)(
                  this.state.fetchingCompanies
                )("female")}
                options={sortBy(this.state.companies, ["label"])}
                onChange={(e, newValue) => {
                  const shifts = [];
                  change("shift", null);
                  this.setState({ shifts, fetchingShifts: true });
                  db.collection("companies")
                    .doc(newValue.value)
                    .collection("shifts")
                    .get()
                    .then((shiftSnapshot) => {
                      shiftSnapshot.forEach((shift) =>
                        shifts.push({
                          value: shift.id,
                          label: shift.data().name,
                        })
                      );
                      this.setState({ shifts, fetchingShifts: false });
                    })
                    .catch((e) => console.log(e));
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Nome"
                placeholder="Nome"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Field
                name="email"
                type="text"
                component={renderField}
                label="Email"
                placeholder="Email"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          {!initialValues ? (
            <Col md={4}>
              <FormGroup>
                <Field
                  name="password"
                  type="password"
                  component={renderField}
                  label="Senha"
                  placeholder="Senha"
                  disabled={initialValues}
                />
              </FormGroup>
            </Col>
          ) : null}
          <Col md={initialValues ? 6 : 4}>
            <FormGroup>
              <Field
                name="role"
                component={renderSelect}
                label="Nível de acesso"
                disabled={!this.state.roles.length}
                placeholder={this._handlePlaceholder(this.state.roles)(
                  this.state.fetchingRoles
                )("male")}
                options={sortBy(this.state.roles, ["label"])}
              />
            </FormGroup>
          </Col>

          <Col md={initialValues ? 6 : 4}>
            <FormGroup>
              <Field
                name="shift"
                component={renderSelect}
                label="Turno"
                disabled={!this.state.shifts.length}
                placeholder={this._handlePlaceholder(this.state.shifts)(
                  this.state.fetchingShifts
                )("male")}
                options={sortBy(this.state.shifts, ["label"])}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };

  _handlePlaceholder = (stateProperty) => (stateFetch) => (gender) => {
    if (stateFetch) {
      return "Aguarde";
    }

    if (!stateFetch && !stateProperty.length) {
      return `Nenhum${gender === "male" ? "" : "a"} cadastrad${
        gender === "male" ? "o" : "a"
      }`;
    }

    if (!stateFetch && stateProperty.length) {
      return "Selecione";
    }
  };
}

UserForm = reduxForm({ form: "UserForm", validate })(UserForm);
export default UserForm;



// WEBPACK FOOTER //
// ./src/forms/UserForm.jsx